import {
  Box,
  FormLabel,
  Input,
  InputGroup,
  InputLeftAddon,
  InputRightAddon,
  Text,
} from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React from 'react';

const CommonInput = ({
  labelText,
  textColor,
  brandStars,
  placeholder,
  register,
  errors,
  name,
  type,
  value,
  readOnly,
  isDisabled = false,
  isValidate = true,
  isEmailReadOnly,
  isAddPercentage = false,
  isAddEuroPrefix = false,
  prefixText,
}) => {
  const resolvedPrefix = prefixText ?? (isAddEuroPrefix ? '€' : null);
  return (
    <>
      <Box>
        <FormLabel
          display="flex"
          ms="4px"
          fontSize="sm"
          fontWeight="500"
          color={textColor}
          mb="8px"
        >
          {labelText}
          {isValidate && <Text color={brandStars}>*</Text>}
        </FormLabel>
        <InputGroup position={'relative'}>
          {resolvedPrefix && (
            <InputLeftAddon
              position="absolute"
              left="16px"
              top="50%"
              transform={'translateY(-50%)'}
              background={'none'}
              border={'none'}
              borderRadius="0"
              p={0}
              zIndex={1}
            >
              {resolvedPrefix}
            </InputLeftAddon>
          )}
          <Input
            type={type}
            isRequired
            variant="auth"
            fontSize="sm"
            placeholder={placeholder}
            fontWeight="500"
            size="lg"
            borderRadius="16px !important"
            {...register}
            name={name}
            value={value}
            readOnly={readOnly}
            isDisabled={isDisabled}
            sx={{
              backgroundColor: isEmailReadOnly ? '#f5f5f5' : 'white',
              color: isEmailReadOnly ? '#888' : '#000',
              border: isEmailReadOnly ? '1px solid #ddd' : '1px solid #ccc',
              cursor: isEmailReadOnly ? 'not-allowed' : 'text',
              paddingLeft: resolvedPrefix ? '40px' : '16px',
            }}
            onInput={(e) => {
              if (type === 'number') {
                const input = e.target;
                let value = input.value;
                const previousValue = input.value;
                value = value.replace(/[^0-9.]/g, '');
                const parts = value.split('.');
                if (parts.length > 2) {
                  value = `${parts[0]}.${parts.slice(1).join('')}`;
                }
                if (parts.length === 2 && parts[1].length > 2) {
                  value = `${parts[0]}.${parts[1].substring(0, 2)}`;
                }

                if (value !== previousValue) {
                  input.value = value;
                }
              }
            }}
            onKeyDown={(e) => {
              if (type === 'number') {
                // Prevent 'e', 'E', '+', '-' characters
                if (['e', 'E', '+', '-'].includes(e.key)) {
                  e.preventDefault();
                }
                const { value, selectionStart } = e.target;
                const decimalIndex = value.indexOf('.');

                if (decimalIndex >= 0 && selectionStart > decimalIndex) {
                  const digitsAfterDecimal = value.length - decimalIndex - 1;
                  if (
                    digitsAfterDecimal >= 2 &&
                    selectionStart > decimalIndex &&
                    e.key !== 'Backspace' &&
                    e.key !== 'Delete' &&
                    e.key !== 'ArrowLeft' &&
                    e.key !== 'ArrowRight'
                  ) {
                    e.preventDefault();
                  }
                }
              }
            }}
          />
          {isAddPercentage && (
            <InputRightAddon
              position="absolute"
              right="16px"
              top="50%"
              transform={'translateY(-50%)'}
              background={'none'}
              border={'none'}
              borderRadius="0"
              p={0}
            >
              %
            </InputRightAddon>
          )}
        </InputGroup>
        {errors && (
          <p style={{ color: 'red', fontSize: '14px' }}>{errors?.message}</p>
        )}
      </Box>
    </>
  );
};

CommonInput.propTypes = {
  labelText: PropTypes.string.isRequired,
  textColor: PropTypes.string,
  brandStars: PropTypes.string,
  placeholder: PropTypes.string,
  register: PropTypes.object,
  errors: PropTypes.object,
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  value: PropTypes.string,
  readOnly: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isValidate: PropTypes.bool,
  isEmailReadOnly: PropTypes.bool,
  isAddPercentage: PropTypes.bool,
  isAddEuroPrefix: PropTypes.bool,
  prefixText: PropTypes.string,
};

export default CommonInput;
